<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <div class="panel panel-primary">
                    <div class="panel-heading">
                        <h3>Ordenar Produtos</h3>
                    </div>
                    <div class="panel-body">
                        <div class="row" v-if="!order">
                            <div class="col-md-8">
                                <div class="form-group">
                                    <label for="products">Produtos</label>
                                    <select name="products[]" id="products" v-model="ordered" size="8" multiple>
                                        <option :value="index" v-for="(product, index) in products">
                                            {{ product.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-12 m-t-sm">
                                <button class="btn btn-primary" @click="setProducts">Ordenar Produtos <i class="fa fa-shopping-bag"></i></button>
                            </div>
                        </div>

                        <div class="row" v-if="order">
                            <div class="col-md-12">
                                <draggable v-model="selected" :list="selected" class="dragArea">
                                    <li v-for='(product,index) in selected' :key="product.id" class="list-group-item clearfix draggable">
                                        <i class="mdi mdi-drag pull-left" ></i>
                                        <i class="pull-left fa fa-2x fa-arrows-v align-middle"></i>
                                        <span class="pull-left stages" :id="'stage' + product.id">{{ index + 1 }}. {{ product.name }} </span>
                                        <button class="btn btn-danger pull-right" @click="remove(product, index)">
                                            <i class="fa fa-trash"></i>
                                        </button>
                                    </li>
                                </draggable>
                            </div>
                            <div class="col-md-12 m-t-md">
                                <button class="btn btn-info" @click="back"><i class="fa fa-arrow-left"></i> Voltar</button>
                                <button class="btn btn-success" @click="save" style="margin-left:3px;">Salvar Ordenação <i class="fa fa-save"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import draggable from 'vuedraggable';
    import { postReorder } from "../../utils";

    export default{
        data: function(){
            return {
                products: [],
                selected: [],
                ordered: [],
                order: false
            }
        },
        components: {
            draggable
        },
        methods: {
            getProductsArray: function(data){
                let array = [];
                $.each(data, function(index, value){
                    if(value.sort_by){
                        array.push(index);
                    }
                });
                return array;
            },
            getProducts: function(){
                let self = this;
                let api  = self.$store.state.api + 'product?paginated=false';
                let products = $('#products');

                self.$http.get(api)
                    .then((response) => {
                        self.products = response.data.data;
                        self.ordered  = self.getProductsArray(self.products);
                    })
                    .then(() => {
                        products.bootstrapDualListbox();
                        products.ready(function () {
                            products.bootstrapDualListbox('refresh', true);
                        });
                    })
                    .catch((error) => {
                        self.$message(null, 'Ocorreu um erro ao buscar os Produtos', 'error');
                    });
            },
            setProducts: function(){
                const self   = this;
                let products = self.selected;

                $('#products').find(':selected').each(function(){
                    products.push(self.products[$(this).val()]);
                });

                self.selected = products;
                self.order = true;
            },
            save: function(){
                const self = this;

                postReorder(self, self.selected, "sort/product", self.getProductsArray);
            },
            remove: function(product, index){
                const self = this;
                const api  = self.$store.state.api + 'product/' + product.id;

                let array  = [];
                $.each(self.selected, function(key, value){
                    if(index !== key){
                        array.push(value);
                    }
                });

                self.$http.put(api, {
                    sort_by: null
                })
                    .then((response) => {
                        this.selected = array;
                    });
            },
            back: function(){
                window.location.reload();
            }
        },
        mounted: function(){
            this.getProducts();
        }
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ProductOrder/Index.vue